import React, { useEffect, useState } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import { FaHome} from 'react-icons/fa';
import { FaLightbulb, FaMessage, FaRegMessage, FaWallet } from "react-icons/fa6";
import { FaMedapps } from "react-icons/fa6";
import { NavLink } from "react-router-dom";

    function BottomNav() {
      return (
        <Navbar bg="success" data-bs-theme="dark" variant="light" fixed="bottom" className="d-md-none">
          <Container className="justify-content-around">
            <Nav className="w-100 justify-content-around">
              <Nav.Link as={NavLink} to="/" className="text-center">
                <FaHome size={24} /><br />Home
              </Nav.Link>
              <Nav.Link as={NavLink} to="/Payments"  className="text-center">
                <FaWallet size={24} /><br />Payments
              </Nav.Link>
              <Nav.Link  as={NavLink} to="/messages"  className="text-center">
                <FaMessage size={24} /><br />Messages
              </Nav.Link>
              <Nav.Link  as={NavLink} to="/content"  className="text-center">
                <FaLightbulb size={24} /><br />Content
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar>
      );
    }

    export default BottomNav;